import { render } from "./Verification.vue?vue&type=template&id=c9eb8f9e"
import script from "./Verification.vue?vue&type=script&lang=js"
export * from "./Verification.vue?vue&type=script&lang=js"
script.render = render

export default script